
import { TEXT_COLOR_RED, TEXT_COLOR_NORMAL } from "@/store";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class MenuContacto extends Vue {
  public textoTel = "M. (+34) 606 45 17 22"
  public textoTel2 = "T / F. (+34) 91 872 50 74";
  public textoMail = "info@ingenieriahumana.es"
 
  public hovering = false;

  mounted() {
    // console.log("MenuContacto mounted");
    this.hovering = false;
  }

  get textColor() {
    return this.hovering ? TEXT_COLOR_RED : TEXT_COLOR_NORMAL;
  }

  get mailStyle() {
      let style =  {
        top: "260px",
        color: this.textColor,
        // fontWeight: 500,
      };
      // console.log(style);
      return style;
  }

  sendMail() {
    // console.log("sendMail");
    const win: Window = window;
    win.location = "mailto:ingo@ingenieriahumana.es";
  }

}
